import { FormType, ReportJSON } from '@aloft/toolkit-shared';

import { createDirtyNode } from '../utils.ts';
import { create1004FormNode } from './fnma1004.ts';
import { create1004cFormNode } from './fnma1004c.ts';
import { create1025FormNode } from './fnma1025.ts';
import { create2055FormNode } from './fnma2055.ts';
import { createGpResidentialFormNode } from './gpResidential.ts';

export function createFormsNode(
  doc: XMLDocument,
  reportJSON: ReportJSON,
  formType: FormType,
): HTMLElement {
  const formsNode = createDirtyNode(doc, 'FORMS');

  let majorFormNode: HTMLElement | undefined;
  switch (formType) {
    case FormType.fnma1004:
      majorFormNode = create1004FormNode(doc, reportJSON);
      break;
    case FormType.fnma2055:
      majorFormNode = create2055FormNode(doc, reportJSON);
      break;
    case FormType.fnma1004c:
      majorFormNode = create1004cFormNode(doc, reportJSON);
      break;
    case FormType.fnma1025:
      majorFormNode = create1025FormNode(doc, reportJSON);
      break;
    case FormType.gpResidential:
      majorFormNode = createGpResidentialFormNode(doc, reportJSON);
      break;
    default:
      throw new Error(`Form Type ${formType} not yet supported`);
  }

  if (majorFormNode) formsNode.appendChild(majorFormNode);

  return formsNode;
}
